import { render, staticRenderFns } from "./AccountHistoryProductTabs.vue?vue&type=template&id=16e59a9e&"
import script from "./AccountHistoryProductTabs.vue?vue&type=script&lang=js&"
export * from "./AccountHistoryProductTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports